import React, { FC, useState, useEffect, useRef } from 'react';
import calendar from 'calendar';
import moment from 'moment';
import './style.scss';

interface Props {
  active: string;
  setDate?: string;
  direction?: string;
  clickEvt: (str: string, target: HTMLElement) => void;
  minDate?: string; // 'YYYYMMDD' - 선택 가능한 최소일
  maxDate?: string; // 'YYYYMMDD' - 선택 가능한 최대일
}

const Calendar: FC<Props> = ({
  setDate = moment().format('YYYYMM'),
  clickEvt,
  active,
  direction = 'left',
  minDate,
  maxDate,
}) => {
  // STATE
  const [seDate, setSeDate] = useState({
    selectDate: setDate,
    calcDate: setDate,
  });
  useEffect(() => {
    setSeDate({ selectDate: setDate, calcDate: setDate });
  }, [setDate]);

  /*
   * :: Check OutSide
   */
  const boxOutsideRef = useRef<HTMLDivElement | null>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (boxOutsideRef.current && !boxOutsideRef.current.contains(event.target as HTMLElement)) {
      if (active === '_active') {
        clickEvt('', event.target as HTMLElement);
      }
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [active]);

  // Calendar Data
  const cal = new calendar.Calendar();

  const nowYear = Number(moment(seDate.calcDate, ['YYYY.MM.DD']).format('YYYY'));
  const nowMonthStr = moment(seDate.calcDate, ['YYYY.MM.DD']).format('MM');
  const nowMonth = Number(nowMonthStr);

  const calMonth = cal.monthDates(nowYear, nowMonth - 1);
  const calLabel = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  // const jobDay = ['20230115', '20230118'];
  const jobDay: string[] = [];
  const holDay: string[] = ['20230123', '20230124'];

  // Event
  const minYM = minDate ? minDate.slice(0, 6) : null;
  const maxYM = maxDate ? maxDate.slice(0, 6) : null;

  const calcYear = (type: string) => {
    // setDate.date;
    let date = moment(seDate.calcDate).subtract(1, 'months').format('YYYYMM');
    if (type === 'up') date = moment(seDate.calcDate).add(1, 'years').format('YYYYMM');
    if (type === 'down') date = moment(seDate.calcDate).subtract(1, 'years').format('YYYYMM');
    if (minYM && date < minYM) return;
    if (maxYM && date > maxYM) return;
    setSeDate({ ...seDate, calcDate: date });
  };
  const calcMonth = (type: string) => {
    // setDate.date;
    let date = moment(seDate.calcDate).subtract(1, 'months').format('YYYYMM');
    if (type === 'up') date = moment(seDate.calcDate).add(1, 'months').format('YYYYMM');
    if (type === 'down') date = moment(seDate.calcDate).subtract(1, 'months').format('YYYYMM');
    if (minYM && date < minYM) return;
    if (maxYM && date > maxYM) return;
    setSeDate({ ...seDate, calcDate: date });
  };
  const isDisabledDay = (dayStr: string) => {
    if (minDate && dayStr < minDate) return true;
    if (maxDate && dayStr > maxDate) return true;
    return false;
  };
  const clickEvent = (day: string, e: React.MouseEvent) => {
    const date = moment(seDate.calcDate, ['YYYY.MM.DD']).format('YYYYMM');
    const fullDate = date + day;
    if (isDisabledDay(fullDate)) return;
    clickEvt(fullDate, e.target as HTMLElement);
  };

  return (
    <div className={['_calendar_box_div', direction, active].join(' ')} ref={boxOutsideRef}>
      <div className="_box">
        <div className="_top_div">
          {/* <div className="_btn_div">X</div> */}
          <div className="_date_div">
            <div className="_year">
              <div className="_btn _up" onClick={e => calcYear('up')}>
                <i className="ri-arrow-drop-up-line" />
              </div>
              <div className="_text">{nowYear}</div>
              <div className="_btn _down" onClick={e => calcYear('down')}>
                <i className="ri-arrow-drop-down-line" />
              </div>
            </div>
            <div className="_month">
              <div className="_btn _up" onClick={e => calcMonth('up')}>
                <i className="ri-arrow-drop-up-line" />
              </div>
              <div className="_text">{nowMonthStr}</div>
              <div className="_btn _down" onClick={e => calcMonth('down')}>
                <i className="ri-arrow-drop-down-line" />
              </div>
            </div>
          </div>
        </div>

        <div className="_content_label_div">
          <div className="_row">
            {calLabel.map((item: string, idx: number) => {
              return (
                <div className="_item" key={idx}>
                  {item}
                </div>
              );
            })}
          </div>
        </div>
        <div className="_content_div">
          {calMonth.map((date: Date[], idx: number) => {
            return (
              <div className="_row" key={idx}>
                {date.map((day: Date, i: number) => {
                  const calcStr = moment(day).format('YYYYMMDD');
                  const calcMonStr = Number(moment(day).format('MM'));
                  const calcDayStr = moment(day).format('D');
                  const calcDay = moment(day).format('DD');
                  let otherClass = '';
                  let holClass = '';
                  let jobClass = '';
                  let disabledClass = '';
                  // 공휴일
                  if (holDay.indexOf(calcStr) !== -1) holClass = '_hol';
                  if (i === 0 || i === 6) holClass = '_hol';
                  // 작업일
                  if (jobDay.indexOf(calcStr) !== -1) jobClass = '_job';
                  // 다른달
                  if (calcMonStr !== nowMonth) otherClass = '_other';
                  // 선택일
                  if (calcStr === seDate.selectDate) otherClass = '_select';
                  // 선택 가능 기간(minDate ~ maxDate) 밖
                  if (isDisabledDay(calcStr)) disabledClass = '_disabled';

                  return (
                    <div className="_item" key={i}>
                      <div
                        className={['_text', otherClass, holClass, jobClass, disabledClass].join(
                          ' ',
                        )}
                        onClick={(e: React.MouseEvent) => clickEvent(calcDay, e)}
                        key={i}
                      >
                        {calcDayStr}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
